import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import Image from "next/image";

const LauncherTeaserModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="relative bg-white dark:bg-metaxseed-black rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6 transform transition-all duration-300 scale-100 animate-pulse-slow border border-gray-200 dark:border-zinc-800">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition-colors"
        >
          <Icon icon="material-symbols:close" className="w-6 h-6" />
        </button>

        {/* Rocket Animation */}
        <div className="text-center">
          <div className="inline-block p-4 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full mb-4 animate-bounce">
            <Icon icon="ion:rocket" className="w-12 h-12 text-white" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-center text-gray-900 dark:text-white mb-4 gothamBold">
          MXS Play Launcher
        </h2>

        {/* Coming Soon Badge */}
        <div className="flex justify-center mb-4">
          <span className="bg-gradient-to-r from-orange-400 to-pink-500 text-white px-4 py-2 rounded-full text-sm font-semibold animate-pulse">
            🚀 Coming Soon
          </span>
        </div>

        {/* Description */}
        <div className="text-center text-gray-600 dark:text-gray-300 mb-6 gothamBook">
          <p className="mb-3">
            A new and improved version of MXS Play Launcher is currently under development!
          </p>
          <p className="text-sm">
            Get ready for enhanced features, better performance, and an amazing gaming experience.
          </p>
        </div>

        {/* Features Preview */}
        <div className="space-y-3 mb-6">
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span className="text-sm text-gray-700 dark:text-gray-300">Enhanced game library</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
            <span className="text-sm text-gray-700 dark:text-gray-300">Improved performance</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
            <span className="text-sm text-gray-700 dark:text-gray-300">Better user experience</span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 gothamMedium"
          >
            Stay Tuned!
          </button>
          
          <div className="text-center">
            <p className="text-xs text-gray-500 dark:text-gray-400">
              We'll notify you when it's ready
            </p>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute -top-2 -left-2 w-4 h-4 bg-yellow-400 rounded-full animate-ping"></div>
        <div className="absolute -bottom-2 -right-2 w-3 h-3 bg-green-400 rounded-full animate-ping" style={{ animationDelay: '1s' }}></div>
      </div>
    </div>
  );
};

export default LauncherTeaserModal; 